import { PersonData } from '@tymbe/schema/person.interface';
import { UserAvatar } from '../../../../components/Avatar/UserAvatar';
import moment from 'moment';
import classNames from 'classnames';
import { BadgePill } from '@tymbe/ty-components/indicators';

type TyTimelineProfileProps = {
  date: string;
  person?: PersonData;
  variant?: 'regular' | 'deleted';
  showDeletedBadgePill?: boolean;
};

export const TyTimelineProfile = ({
  date,
  person,
  variant,
  showDeletedBadgePill = false,
}: TyTimelineProfileProps) => {
  const formattedDate = moment(date).format('DD. MM. YYYY, HH:mm');
  const name = person ? `${person.first_name} ${person.last_name}` : 'System';
  return (
    <div className="pb-2 flex">
      <UserAvatar person={person} />
      <div className="flex flex-col pl-2">
        <span className="text-caption-sm text-secondary-400">
          {formattedDate}
        </span>
        <span
          className={classNames(
            'text-body-2-lg',
            variant === 'deleted' && 'text-secondary-400'
          )}
        >
          {name}
        </span>
      </div>
      {showDeletedBadgePill && (
        <BadgePill className="h-min ml-2 !rounded-2xl" variant="error">
          Stornováno
        </BadgePill>
      )}
    </div>
  );
};
